import React from 'react';
import { Box } from '@mui/material';
import InvoiceItem, { InvoiceItemProps } from '../InvoiceItem/InvoiceItem';

export type InvoiceListProps = {
    items: Array<InvoiceItemProps>;
    showTimestampAndBlame?: boolean;
};

const InvoiceList: React.FunctionComponent<InvoiceListProps> = function (props) {
    const { items, showTimestampAndBlame = false } = props;
    const wrapperSx = {
        display: 'flex',
        flexDirection: 'column',
        gap: '8px 0',
    };
    return (
        <Box
            sx={wrapperSx}
            data-testid="invoice-list"
        >
            {items.map((item) => (
                <InvoiceItem
                    key={item.id?.toString() || item.label}
                    id={item.id}
                    title={item.title}
                    label={item.label}
                    status={item.status}
                    feedback={item.feedback}
                    createdBy={showTimestampAndBlame ? item.createdBy : undefined}
                    createdAt={showTimestampAndBlame ? item.createdAt : undefined}
                    amount={item.amount}
                    onDownload={item.onDownload}
                    onShow={item.onShow}
                    validateInvoice={item.validateInvoice}
                    deleteInvoice={item.deleteInvoice}
                />
            ))}
        </Box>
    );
};

export default InvoiceList;
